import React from 'react';
import { useDispatch } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import snakeCaseKeys from 'snakecase-keys';
import { LinkBtn, Icon } from '../../components';
import { createSurveyRequest } from '../../requests/surveys';
import { sendAlert } from '../../actions/utils';
import SurveyForm from './SurveyForm';
import survey from './survey';

const SurveyNew = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleCreateRequest = (surveyValues, setSubmitting) => {
    const { survey: surveyData } = surveyValues;
    const params = snakeCaseKeys({ survey: surveyData }, { deep: true });

    if (surveyData.questionsAttributes) {
      surveyData.questionsAttributes.forEach((q, qIndex) => {
        if (q.questionChoicesAttributes) {
          q.questionChoicesAttributes.forEach((c, cIndex) => {
            if (c.image instanceof File || c.image instanceof Blob) {
              params.survey.questions_attributes[qIndex].question_choices_attributes[cIndex].image = c.image;
            }
          });
        }
      });
    }

    createSurveyRequest({
      dispatch,
      params,
      successCallback: () => {
        dispatch(sendAlert({ kind: 'success', message: 'Encuesta creada con éxito' }));
        history.push('/surveys');
      },
      callback: () => setSubmitting(false)
    });
  };

  return (
    <>
      <Row className="m-top mb-1">
        <LinkBtn variant="circle-dark" className="btn-circle" to="/surveys">
          <Icon icon="chevron-back" />
        </LinkBtn>
        <Col>
          <h2 className="mt-1">Nueva Encuesta</h2>
        </Col>
      </Row>
      <SurveyForm survey={survey} action="new" formRequest={handleCreateRequest} />
    </>
  );
};

export default SurveyNew;
